import AWS from 'aws-sdk';

const cognito = new AWS.CognitoIdentityServiceProvider({
    region: process.env.REACT_APP_AWS_REGION,
});

export interface AuthChallenge {
    challengeName: string;
    session: string;
    challengeParameters?: any;
}

export interface AuthResult {
    accessToken?: string;
    idToken?: string;
    refreshToken?: string;
    challenge?: AuthChallenge;
}

export const initiateEmailAuth = async (email: string): Promise<AuthResult> => {
    const params = {
        AuthFlow: 'CUSTOM_AUTH',
        ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
        AuthParameters: {
            USERNAME: email,
        },
    };

    try {
        const response = await cognito.initiateAuth(params).promise();
        
        if (response.ChallengeName) {
            return {
                challenge: {
                    challengeName: response.ChallengeName,
                    session: response.Session!,
                    challengeParameters: response.ChallengeParameters,
                }
            };
        }
        
        return {
            accessToken: response.AuthenticationResult?.AccessToken,
            idToken: response.AuthenticationResult?.IdToken,
            refreshToken: response.AuthenticationResult?.RefreshToken,
        };
    } catch (error) {
        console.error('Error initiating auth:', error);
        throw error;
    }
};

export const respondToEmailChallenge = async (email: string, code: string, session: string): Promise<AuthResult> => {
    const params = {
        ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
        ChallengeName: 'CUSTOM_CHALLENGE',
        Session: session,
        ChallengeResponses: {
            USERNAME: email,
            ANSWER: code,
        },
    };

    try {
        const response = await cognito.respondToAuthChallenge(params).promise();

        console.log('Response to challenge:', response);
        if (response.ChallengeName) {
            return {
                challenge: {
                    challengeName: response.ChallengeName,
                    session: response.Session!,
                    challengeParameters: response.ChallengeParameters,
                }
            };
        }
        
        return {
            accessToken: response.AuthenticationResult?.AccessToken,
            idToken: response.AuthenticationResult?.IdToken,
            refreshToken: response.AuthenticationResult?.RefreshToken,
        };
    } catch (error) {
        console.error('Error responding to challenge:', error);
        throw error;
    }
};

// Function to resend OTP code using the same session
export const resendOtpCode = async (email: string): Promise<AuthResult> => {
    // Use the same flow as initiateEmailAuth to ensure consistent session handling
    return await initiateEmailAuth(email);
};
